import { useState } from 'react'
import { Icon } from '../components/Icons'
import { SectionHead } from '../components/UI'
import corporateBanner from '../assets/logo/B2B Travel Solutions at the Airport.png'

const SERVICES = [
  {
    icon: 'plane',
    title: 'Air Travel Management',
    desc: 'Best fares, flexible booking, preferred airline tie-ups & multi-city routing for teams of any size.',
  },
  {
    icon: 'hotel',
    title: 'Hotel & Accommodation',
    desc: 'Corporate rate negotiation, group bookings, business class hotels & serviced apartments.',
  },
  {
    icon: 'briefcase',
    title: 'MICE Solutions',
    desc: 'Meetings, incentives, conferences & exhibitions — end-to-end event management globally.',
  },
  {
    icon: 'passport',
    title: 'Visa & Documentation',
    desc: 'Business visa fast-track, invitation letters, travel insurance & document management.',
  },
  {
    icon: 'users',
    title: 'Team Offsites & Retreats',
    desc: 'Curated team-building, wellness retreats & leadership offsite planning.',
  },
  {
    icon: 'shield',
    title: 'Duty of Care',
    desc: '24/7 traveller tracking, emergency response protocols & travel risk management.',
  },
]

const FORM_FIELDS = [
  { label: 'Company Name', placeholder: 'Company Name', type: 'text', span: 1 },
  { label: 'Your Name', placeholder: 'Your Name', type: 'text', span: 1 },
  { label: 'Email Address', placeholder: 'email@company.com', type: 'email', span: 1 },
  { label: 'Phone Number', placeholder: '+91 XXXXX XXXXX', type: 'tel', span: 1 },
  { label: 'Destination', placeholder: 'Where do you want to go?', type: 'text', span: 1 },
  { label: 'No. of Travellers', placeholder: 'Number of travellers', type: 'number', span: 1 },
]

const inputStyle = {
  width: '100%',
  padding: '11px 14px',
  border: '1.5px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '13px',
  background: '#f8fafc',
}
const labelStyle = {
  display: 'block',
  fontSize: '9px',
  fontWeight: 800,
  letterSpacing: '1.5px',
  color: 'var(--brand)',
  marginBottom: '6px',
  textTransform: 'uppercase',
}

function ServiceCard({ s }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="hover-card"
      style={{
        background: '#fff',
        border: '1.5px solid #e2e8f0',
        borderRadius: '12px',
        padding: '28px 24px',
        transition: 'all 0.3s',
      }}
    >
      <div
        style={{
          width: '44px',
          height: '44px',
          background: hovered ? 'rgba(255,182,0,0.15)' : 'var(--brand-lt)',
          borderRadius: '11px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px',
          transition: 'all 0.3s',
        }}
      >
        <Icon name={s.icon} size={20} color={hovered ? 'var(--secondary)' : 'var(--brand)'} />
      </div>
      <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#0d1117', margin: '0 0 8px' }}>
        {s.title}
      </h3>
      <p style={{ fontSize: '12px', color: '#6b7a8f', lineHeight: 1.7, margin: 0 }}>{s.desc}</p>
    </div>
  )
}

const fieldKeys = {
  'Company Name': 'companyName',
  'Your Name': 'yourName',
  'Email Address': 'emailAddress',
  'Phone Number': 'phoneNumber',
  Destination: 'destination',
  'No. of Travellers': 'noOfTravellers',
}

export default function Corporate() {
  // WhatsApp Helper function
  const sendToWhatsApp = (message) => {
    const phone = '7092210922'
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
    window.open(url, '_blank')
  }

  const [formData, setFormData] = useState({
    companyName: '',
    yourName: '',
    emailAddress: '',
    phoneNumber: '',
    destination: '',
    noOfTravellers: '',
    requirements: '',
  })

  const handleCorporateSubmit = (e) => {
    e.preventDefault()
    const message = `Hello DIRA HOLIDAYS! I want to request a corporate travel quote.

*Corporate Travel Request:*
- *Company Name:* ${formData.companyName}
- *Your Name:* ${formData.yourName}
- *Email:* ${formData.emailAddress}
- *Phone Number:* ${formData.phoneNumber}
- *Destination:* ${formData.destination}
- *No. of Travellers:* ${formData.noOfTravellers}
- *Requirements:* ${formData.requirements}`

    sendToWhatsApp(message)
  }

  return (
    <div className="page-enter">
      {/* Hero Banner */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          background: '#0d1117',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        }}
      >
        <img
          src={corporateBanner}
          alt="B2B Travel Solutions - Corporate Business Tours"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '440px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      {/* Quick CTA bar */}
      <div
        style={{
          background: '#0d1117',
          padding: '20px 32px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <div
          style={{
            maxWidth: '1100px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
            flexWrap: 'wrap',
          }}
        >
          <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', fontWeight: 600 }}>
            Ready to plan your corporate travel or executive retreat?
          </span>
          <button
            onClick={() =>
              document.getElementById('corporate-form')?.scrollIntoView({ behavior: 'smooth' })
            }
            style={{
              padding: '10px 22px',
              background: 'var(--brand)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: 800,
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            Get a Corporate Quote
          </button>
          <button
            onClick={() =>
              sendToWhatsApp(
                'Hello DIRA HOLIDAYS! I would like to talk to your MICE Team regarding corporate travel.'
              )
            }
            style={{
              padding: '10px 22px',
              background: 'transparent',
              border: '2px solid var(--secondary)',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: 800,
              color: 'var(--secondary)',
              cursor: 'pointer',
            }}
          >
            Talk to Our MICE Team
          </button>
        </div>
      </div>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '64px 32px' }}>
        <SectionHead eyebrow="What We Offer" title="Corporate Travel Services" />

        {/* Services grid */}
        <div
          className="Corporate_services_grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3,1fr)',
            gap: '20px',
            marginBottom: '56px',
          }}
        >
          {SERVICES.map((s) => (
            <ServiceCard key={s.title} s={s} />
          ))}
        </div>

        {/* Enquiry form */}
        <form
          id="corporate-form"
          onSubmit={handleCorporateSubmit}
          style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '40px',
            border: '1.5px solid #e2e8f0',
          }}
        >
          <h3 style={{ fontSize: '24px', fontWeight: 800, color: '#0d1117', margin: '0 0 26px' }}>
            Request a Corporate Quote
          </h3>
          <div
            className="Corporate_enquiry_form_grid"
            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}
          >
            {FORM_FIELDS.map((f) => {
              const key = fieldKeys[f.label]
              return (
                <div key={f.label}>
                  <label style={labelStyle}>{f.label}</label>
                  <input
                    type={f.type}
                    placeholder={f.placeholder}
                    style={inputStyle}
                    required
                    value={formData[key]}
                    onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
                  />
                </div>
              )
            })}
            <div style={{ gridColumn: 'span 2' }}>
              <label style={labelStyle}>Requirements</label>
              <textarea
                rows={3}
                placeholder="Tell us about your travel requirements, special needs, preferred dates..."
                style={{ ...inputStyle, resize: 'vertical' }}
                value={formData.requirements}
                onChange={(e) => setFormData({ ...formData, requirements: e.target.value })}
              />
            </div>
          </div>
          <button
            type="submit"
            style={{
              marginTop: '20px',
              padding: '13px 34px',
              background: 'var(--brand)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: 800,
              color: '#fff',
              boxShadow: '0 4px 12px rgba(2,2,191,0.2)',
            }}
          >
            Submit Enquiry
          </button>
        </form>
      </div>
    </div>
  )
}
